<div class="loading" *ngIf="loader"></div>
<form>
    <div class="row no-gutters content_top_margin">
        <div class="col-12">
            <fieldset aria-required="true" aria-labelledby="lblCustRelationRadio">
                <legend role="radiogroup" class="cibcLabel legend_display sectionHeading_one bot_spa_aft_sect_heading"
                    id="lblCustRelationRadio">
                    <ng-container *ngIf="cibcCustomerObj.hide_show=='Yes'">
                        {{'cibc-customer-relationship.titleTextBox1' | translate }}
                    </ng-container>
                    <ng-container *ngIf="cibcCustomerObj.hide_show=='No'">
                        {{'cibc-customer-relationship.titleTextBox' | translate }}
                    </ng-container>
                </legend>
                <ng-container *ngIf="both===true">
                    <div class="row no-gutters bot_spa_aft_sect_heading">
                        <div class="col-md-7 col-12">
                            <label
                                [class]="borderColorYB ? 'selectBorder d-flex radio_button_border  field_lable_bot_margin_unset' : displayValidation ? 'validationBorder d-flex radio_button_border  field_lable_bot_margin_unset':'nonSelectBorder d-flex radio_button_border  field_lable_bot_margin_unset' ">
                                <div
                                    [ngClass]="(!borderColorY && !borderColorN && selectionN!=null && selectionY != null) ? 'cst-rd-check':'cst-rd'">
                                    <input tabindex="0" aria-describedby="errMsg" id="yesBoth"
                                        [attr.aria-checked]="selectionYB" type="radio" name="alpha"
                                        [checked]="selectionYB" (click)="buttonDisplay('yesBoth')" />
                                    <div class="border-on-focus"></div>
                                </div>
                                <span class="ml-2">
                                    {{ 'cibc-customer-relationship.yesBoth' | translate }}
                                </span>
                            </label>
                        </div>
                    </div>
                    <div class="row no-gutters bot_spa_aft_sect_heading">
                        <div class="col-md-7 col-12">
                            <label
                                [class]="borderColorY ? 'selectBorder d-flex radio_button_border  field_lable_bot_margin_unset' : displayValidation ? 'validationBorder d-flex radio_button_border  field_lable_bot_margin_unset':'nonSelectBorder d-flex radio_button_border  field_lable_bot_margin_unset' ">
                                <div class="nobtn"
                                    [ngClass]="(!borderColorYB && !borderColorN && selectionN!=null && selectionYB != null) ? 'cst-rd-check':'cst-rd'">
                                    <input tabindex="0" aria-describedby="errMsg" id="yes"
                                        [attr.aria-checked]="selectionY" type="radio" name="alpha"
                                        [checked]="selectionY" (click)="buttonDisplay('yes')" />
                                    <div class="border-on-focus"></div>
                                </div>
                                <span class=" ml-2">
                                    {{ 'cibc-customer-relationship.yesOne' | translate }}
                                </span>
                            </label>
                        </div>
                    </div>
                    <div class="row no-gutters">
                        <div class="col-md-7 col-12">
                            <label
                                [class]="borderColorN? 'selectBorder d-flex radio_button_border  field_lable_bot_margin_unset' : displayValidation ? 'validationBorder d-flex radio_button_border  field_lable_bot_margin_unset':'nonSelectBorder d-flex radio_button_border  field_lable_bot_margin_unset' ">
                                <div class="nobtn"
                                    [ngClass]="(!borderColorY &&!borderColorYB&& selectionY != null&&selectionYB!=null) ? 'cst-rd-check':'cst-rd'">
                                    <input tabindex="0" aria-describedby="errMsg" id="no"
                                        [attr.aria-checked]="selectionN" type="radio" name="alpha"
                                        [checked]="selectionN" (click)="buttonDisplay('no')" />
                                    <div class="border-on-focus"></div>
                                </div>
                                <span class=" ml-2">
                                    {{ 'cibc-customer-relationship.noBoth' | translate }}
                                </span>
                            </label>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="both===false">
                    <div class="row no-gutters">
                        <div class="col-12 d-md-inline-flex">
                            <div>
                                <label
                                    [class]="borderColorY ? 'selectBorder d-flex radio_button_border  field_lable_bot_margin_unset' : displayValidation ? 'validationBorder d-flex radio_button_border  field_lable_bot_margin_unset':'nonSelectBorder d-flex radio_button_border  field_lable_bot_margin_unset' ">
                                    <div [ngClass]="(borderColorY && selectionY != null) ? 'cst-rd-check':'cst-rd'">
                                        <input tabindex="0" aria-describedby="errMsg" id="yes"
                                            [attr.aria-checked]="selectionY" type="radio" name="alpha"
                                            [checked]="selectionY" (click)="buttonDisplay('yes')" />
                                        <div class="border-on-focus"></div>
                                    </div>
                                    <span class=" ml-2">
                                        {{ 'cibc-customer-relationship.yes' | translate }}
                                    </span>
                                </label>
                            </div>
                            <div class="space_between_field">
                                <label
                                    [class]="borderColorN ? ' selectBorder d-flex radio_button_border  field_lable_bot_margin_unset' : displayValidation ? ' validationBorder d-flex radio_button_border  field_lable_bot_margin_unset':' nonSelectBorder d-flex radio_button_border  field_lable_bot_margin_unset' ">
                                    <div [ngClass]="(!borderColorY && selectionY != null) ? 'cst-rd-check':'cst-rd'">
                                        <input tabindex="0" aria-describedby="errMsg" id="no"
                                            [attr.aria-checked]="selectionN" type="radio" name="alpha"
                                            [checked]="selectionN" (click)="buttonDisplay('no')" />
                                        <div class="border-on-focus"></div>
                                    </div>
                                    <span class=" ml-2">
                                        {{ 'cibc-customer-relationship.no' | translate }}
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </fieldset>
            <div class="row no-gutters top_spa_aft_sect_heading">
                <div class="col-12" [ngClass]="displayValidation ? 'd-flex align-items-center errorMsg' : 'd-none'" id="errMsg">
                    <img aria-hidden="true" src="./assets/images/menu_icons/Alert.svg" alt="">
                    <span class="ml-2">{{ 'cibc-customer-relationship.validation' | translate
                        }}</span>
                </div>
            </div>

            <div class="row no-gutters top_height_actionButton content_top_mobile_margin">
                <div class="col-12  d-md-block d-flex  flex-column-reverse">
                    <cancel-button></cancel-button>
                    <button type="button" class="common_btn saveNextBtn_features space_between_button"
                        (click)="onContinue()">{{'buttonallpages.continuelable' | translate }}</button>
                </div>
            </div>
        </div>
    </div>
</form>